import React from "react";
import doctorImg from "../../../assets/images/doctorImg.png";
import bone from "../../../assets/images/bone.png";
import { NavLink } from "react-router-dom";
import rightArrow from "../../../assets/images/right-arrow.svg";
import "react-quill/dist/quill.snow.css";

const About = ({ settingData }) => {
  return (
    <section className="about relative py-[20px]">
      <img src={bone} className="absolute left-[0px] " alt="" />
      <div className="container">
        <div className="flex justify-center items-center ">
          <div className="heading">About Me</div>
        </div>
        <p
          className="md:text-[16px] mt-[10px] text-[15px] !text-[#000D44] font-[500]"
          style={{ whiteSpace: "pre-line" }}
          dangerouslySetInnerHTML={{
            __html: settingData.bio_description,
          }}
        />
        <div className="doc_name flex gap-[15px] flex-wrap items-end mt-[15px] ml-auto w-max ">
          <img src={doctorImg} className="doctorImg" alt="" />
          <div>
            <h4 className="text-[#000D44] md:text-[22px] text-[18px] font-[700] ">
              {settingData.bio_name}
            </h4>
            <p className="font-[500] md:text-[14px] text-[13px] text-[#000D44] ">
              {settingData.bio_designation}
            </p>
          </div>
        </div>
      </div>

      <div className="flex justify-center my-[20px]">
        <NavLink
          to="/survey"
          className="pain_survey_btn  hover:!text-white !text-white !bg-[#1F2B6C]  "
        >
          Take A-Tool&copy; Back Pain survey
          <div className="arrow_icon  flex justify-center !bg-white items-center ">
            <img src={rightArrow} className="w-[30px] invert" alt="" />
          </div>
        </NavLink>
      </div>
    </section>
  );
};

export default About;
